import {
  CoordinateResponse,
  FilesDataResponse,
  Location,
  StreamExtendedResource,
  StreamResource
} from '@api/client';
import { PostMarkerItem } from './post-markers.interfaces';
import { STATUS_NUMBERS } from '../../avatar.constants';
import { formatAppleDeviceModelInText } from '../../../../shared/utils/apple-device-model-names.util';

export interface UserMarkerCustomData {
  _id: string;
  id: number;
  name: string;
  surname: string;
  official?: boolean;
  userDescription: string;
  walkDescription: string;
  online: boolean;
  status: number;
  rating: number;
  ratingTotal: number;
  rate: number;
  avatar: string | null;
  phoneModel: string;
  time: number;
  location: Location;
  frontCameraPrice?: number;
  isAllowFrontCamera?: boolean;
  isAllowControlMovement?: boolean;
  isAllowFreeMode: boolean;
}

export interface UserMarkerCustomDataExt extends UserMarkerCustomData {
  streams?: StreamResource[];
  battery: CustomBatteryInfo;
  files?: FilesDataResponse[];
}

export interface CustomBatteryInfo {
  level: number;
  isCharging: boolean;
}

export interface UserMarkerWithCustomData extends google.maps.marker.AdvancedMarkerElement {
  customData?: UserMarkerCustomData;
}

export interface UserMarkerOptionsWithCustomData extends google.maps.marker.AdvancedMarkerElementOptions {
  customData?: UserMarkerCustomData;
}

export interface StreamMarkerWithCustomData extends google.maps.marker.AdvancedMarkerElement {
  streamDataExt?: StreamExtendedResource;
  isLive?: boolean;
}

export interface StreamMarkerOptionsWithCustomData extends google.maps.marker.AdvancedMarkerElementOptions {
  streamDataExt?: StreamExtendedResource;
  isLive?: boolean;
}

export interface PostMarkerWithCustomData extends google.maps.marker.AdvancedMarkerElement {}

export interface PostMarkerOptionsWithCustomData extends google.maps.marker.AdvancedMarkerElementOptions {}

export interface UserFilterValues {
  hasStreams: boolean | undefined;
  minRate: number | undefined;
  maxRate: number | undefined;
}

export interface UserFilterFormValues extends UserFilterValues {
  online: boolean | undefined;
}

export interface UserFilterCurrentValues extends UserFilterValues {
  statuses: STATUS_NUMBERS[] | undefined;
}

export enum STREAM_FILTER_VALUE {
  LIVE = 'live',
  TODAY = 'today',
  ALL = 'all'
}

export type EventsFilterMode = STREAM_FILTER_VALUE | 'range';

export interface EventsFilterCurrentValues {
  mode: EventsFilterMode;
  dateFrom: string | null;
  dateTo: string | null;
}

export interface CenterCoordinate {
  lat: number;
  lng: number;
}

export function createUserMarkerCustomData(data: CoordinateResponse): UserMarkerCustomData {
  return {
    _id: data?._id,
    location: data?.location,
    rate: data?.rate,
    walkDescription: data?.description,
    // frontCameraPrice: data.front_camera_price,
    // isAllowControlMovement: data.is_allow_control_movement || false,
    // isAllowFrontCamera: data.is_allow_front_camera || false,
    isAllowFreeMode: data?.is_allow_free_mode || false,
    phoneModel: formatAppleDeviceModelInText(data?.phone_model),
    time: data?.time,
    status: data?.status,
    online: data?.status == STATUS_NUMBERS.ONLINE,
    /* AvatarResponse */
    id: data?.user?.id,
    name: data?.user?.name,
    surname: data?.user?.surname,
    official: data?.user?.official,
    avatar: data?.user?.avatar,
    rating: data?.user?.rating,
    ratingTotal: data?.user?.rating_total,
    userDescription: data?.user?.description,
  };
}
